export { default } from "./QuickAccessElementaryBlock";
